import * as Sentry from '@sentry/browser';

import { DEBUG_MODE, getUrlMedia } from '../spdConfig';

import { TextId } from './textSelector';

export enum BalanceSound {
  left = 'left',
  center = 'center',
  right = 'right',
}

export type SoundParam = {
  src: string;
  volume?: number;
  balance?: BalanceSound;
  currentTime?: number;
  text: TextId;
};

const playingSounds: HTMLAudioElement[] = []; // tablica przechowująca referencje do obiektów Audio

export class MySound {
  public static async playSound(sound: SoundParam) {
    // jeśli nie było podane src to powinno być wyliczone z text przed wywołaniem
    await MySound.play(sound.src, sound.volume, sound.balance);
  }

  public static stopSounds() {
    for (const sound of playingSounds) {
      sound.pause();
    }
    DEBUG_MODE && console.log('STOP ALL SOUNDS');
    playingSounds.length = 0;
  }

  public static async play(
    src: string,
    volume?: number,
    balance?: BalanceSound,
    currentTime?: number,
  ) {
    try {
      if (src) {
        const sound2play = new Audio(getUrlMedia() + src);
        if (currentTime) {
          sound2play.currentTime = currentTime;
        } else {
          sound2play.currentTime = 0;
        }

        if (volume) {
          sound2play.volume = volume;
        }
        if (balance) {
          const audioContext = new window.AudioContext();
          const track = audioContext.createMediaElementSource(sound2play);
          const stereoNode = new StereoPannerNode(audioContext, { pan: 0 });

          stereoNode.pan.value = 0; // center
          if (balance === BalanceSound.left) {
            stereoNode.pan.value = -1;
          }
          if (balance === BalanceSound.right) {
            stereoNode.pan.value = 1;
          }
          track.connect(stereoNode).connect(audioContext.destination);
        }

        const promise = new Promise(resolve => {
          sound2play.onended = () => {
            DEBUG_MODE && console.log('SOUND!!!!!');
            resolve(true);
          };
        });

        await sound2play.play();
        playingSounds.push(sound2play);
        DEBUG_MODE && console.log('AFTER PLAY SOUND!!!!!', src);
        await promise;
        DEBUG_MODE && console.log('AFTER PROMISE!!!!!', src);
      }
    } catch (e) {
      Sentry.captureException(e);
      console.error('Sound.play error', e);
    }
  }
}
